import { Component, Input, OnDestroy, OnInit, Signal, computed, signal } from "@angular/core"
import { FormControl } from "@angular/forms"
import { Subscription } from "rxjs"

@Component({
  selector: "ow-validation-mark",
  templateUrl: "./validation-mark.component.html"
})
export class ValidationMarkComponent implements OnInit, OnDestroy {
  @Input({ required: true }) control!: FormControl

  private subscriptions: Subscription[] = []

  private readonly error = signal<null | "unknown" | "required" | "maxDate" | "pattern" | "email" | "match" | "iban" | "maxlength">(
    null
  )
  private readonly hasValue = signal<boolean>(false)
  public readonly iconClass: Signal<string | false> = computed(() => {
    switch (this.error()) {
      case "required":
        return "fa-solid fa-asterisk text-red-500"
      case "maxDate":
        return "fa-solid fa-calendar text-red-500"
      case "pattern":
      case "maxlength":
        return "fa-solid fa-spell-check text-red-500"
      case "email":
        return "fa-solid fa-envelope text-red-500"
      case "match":
        return "fa-solid fa-not-equal text-red-500"
      case "iban":
        return "fa-solid fa-credit-card text-red-500"
      case "unknown":
        return "fa-solid fa-exclamation-circle text-red-500"
      default:
        if (this.hasValue()) {
          return "fa-solid fa-check text-green-500"
        }
    }
    return false
  })
  public readonly tooltip: Signal<string> = computed(() => {
    switch (this.error()) {
      case "required":
        return "Pflichteingabe"
      case "maxDate":
        return "ungültiges Datum"
      case "pattern":
        return "ungültiges Format"
      case "email":
        return "ungültige E-Mail Adresse"
      case "match":
        return "abweichende Eingabe"
      case "iban":
        return "ungültige IBAN"
      case "maxlength":
        return "Eingabe zu lang"
      case "unknown":
        return "ungültige Eingabe"
    }
    return ""
  })

  ngOnInit(): void {
    this.subscriptions = [
      this.control.statusChanges.subscribe(() => {
        this.updateError()
      }),
      this.control.valueChanges.subscribe((value) => {
        this.updateValue()
      })
    ]
    this.updateValue()
    this.updateError()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  private updateValue(): void {
    if (Object.is(this.control.value, undefined) || Object.is(this.control.value, null) || this.control.value === "") {
      this.hasValue.set(false)
    } else {
      this.hasValue.set(true)
    }
  }

  private updateError(): void {
    if (this.control.invalid) {
      const primaryError = Object.keys(this.control.errors!).forEach((error) => {
        switch (error) {
          case "required":
          case "maxDate":
          case "pattern":
          case "email":
          case "match":
          case "iban":
          case "maxlength":
            this.error.set(error)
            return
          default:
            this.error.set("unknown")
        }
      })
    } else {
      this.error.set(null)
    }
  }
}
